module.exports = __webpack_public_path__ + "static/media/ad-lmi-riskcoach-otg.df45fc04.jpg";